module.exports = __webpack_public_path__ + "img/23EB.f5d50994.svg";